import _typeof from "@babel/runtime/helpers/esm/typeof";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import Plugins from './plugins';
import StylePlugin from './plugins/StylePlugin';
import ArrayPlugin from './plugins/ArrayPlugin';
import GradientsPlugin from './plugins/GradientsPlugin';
import Ticker from './animate/ticker';
import Timeline from './animate/timeline';
import Animate from './animate/animate';
import { getInitProps, dataToArray, initAnimProps, flatArray } from './utils';
import ticker from './animate/ticker';
Plugins.push(ArrayPlugin);
Plugins.push(GradientsPlugin);
Plugins.push(StylePlugin);
var tweenId = 0;
var globalTimeline = new Timeline();

var Tween = /*#__PURE__*/function () {
  function Tween(targets, _props) {
    var _this = this;

    _classCallCheck(this, Tween);

    this.targets = void 0;
    this.props = void 0;
    this.timeline = void 0;
    this.animate = void 0;
    this.$reverse = false;
    this.vars = [];
    this.initTime = void 0;
    this.attr = void 0;

    this.init = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(vars) {
        var props;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                props = getInitProps(vars);

                if (_this.targets[0].tagName && !_this.attr) {
                  props.animation = dataToArray(props.animation).map(function (item) {
                    var c = {
                      style: {}
                    };

                    for (var k in item) {
                      //Object.keys(item).forEach(k => {
                      if (k in Plugins || k in initAnimProps) {
                        c[k] = item[k];
                      } else {
                        c.style[k] = item[k];
                      } //});

                    }

                    if (!Object.keys(c.style).length) {
                      delete c.style;
                    } // 时间去掉小数点;


                    if (item.duration) {
                      item.duration = Math.round(item.duration);
                    }

                    if (item.delay) {
                      item.delay = Math.round(item.delay);
                    }

                    if (item.appearTo) {
                      item.appearTo = Math.round(item.appearTo);
                    }

                    if (item.repeatDelay) {
                      item.repeatDelay = Math.round(item.repeatDelay);
                    }

                    return c;
                  });
                }

                _this.animate = new Animate(props);
                _this.animate.id = "TweenOne_".concat(tweenId);
                tweenId++;
                _this.animate.startTime = _this.initTime;
                _this.animate.onChangeChild = _this.onChange;
                _this.animate.onChangeTimeline = _this.onChangeTimeline;
                _this.animate.root = _this;
                _this.animate.parent = _this.timeline;

                _this.animate.init();

              case 11:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }();

    this.renderToDom = function () {
      // vars.forEach((item, i) => {
      for (var i = 0; i < _this.vars.length; i++) {
        var item = _this.vars[i]; // Object.keys(item).forEach((key: string) => {

        for (var key in item) {
          var value = item[key];
          var target = _this.targets[i];

          if (!target) {
            continue;
          }

          if (_this.props.attr && target.tagName && target.setAttribute) {
            if (key === 'style') {
              // Object.keys(value).forEach(key => {
              for (var ck in value) {
                target.style[ck] = value[key];
              } // });

            }

            target.setAttribute(key, value);
          } else if (key in Plugins && target.tagName) {
            var $key = Plugins[key].key;

            if (typeof target[$key] === 'function') {
              target[$key](value.attr, value.path);
            } else if ($key && _typeof(value) === 'object') {
              //Object.keys(value).forEach(ck => {
              for (var _ck in value) {
                var va = value[_ck];
                target[$key][_ck] = va.text || va;
              } //});

            } else if ($key) {
              target[$key] = value;
            }
          } else {
            target[key] = value;
          } // });

        }
      } //});

    };

    this.onChange = function (e) {
      if (e.mode === 'onComplete' && e.render) {
        _this.renderToDom();
      }

      if (e.mode && _this.props.onChange && !e.silence) {
        e.targets = flatArray(e.targets);
        e.vars = flatArray(e.vars);

        _this.props.onChange(e);
      }
    };

    this.onChangeTimeline = function (e) {
      _this.renderToDom(); // 时间轴结束后清除元素上的缓存


      if (e.mode === 'onTimelineComplete') {
        var _e$targets;

        (_e$targets = e.targets) === null || _e$targets === void 0 ? void 0 : _e$targets.forEach(function (item) {
          delete item._tweenOneVars;
        });
      }

      if (e.mode && _this.props.onChangeTimeline) {
        e.targets = flatArray(e.targets);
        e.vars = flatArray(_this.vars);

        _this.props.onChangeTimeline(e);
      }
    };

    this.goto = function (moment, paused) {
      _this.targets.forEach(function (item) {
        if (!item) {
          return;
        } // item._tweenOneVars = {};


        Object.keys(item._tweenOneVars || {}).forEach(function (key) {
          delete item._tweenOneVars[key];
        });
      });

      _this.animate.goto(moment, paused);
    };

    this.kill = function (index) {
      _this.animate.kill(index);
    };

    this.targets = targets;
    this.props = _props;
    this.timeline = globalTimeline;
    this.initTime = Ticker.time;
    this.attr = _props.attr;
    targets.forEach(function (item) {
      _this.vars.push(item._tweenOneVars);
    });
    this.init(_props);
  }

  _createClass(Tween, [{
    key: "paused",
    get: function get() {
      return this.animate.pausedState;
    },
    set: function set(v) {
      this.animate.paused(v);
    }
  }, {
    key: "reverse",
    get: function get() {
      return this.$reverse;
    },
    set: function set(v) {
      this.$reverse = v;
      this.animate.reverse(v);
    }
  }, {
    key: "regionStartTime",
    get: function get() {
      return this.animate.regionStartTime;
    },
    set: function set(v) {
      this.animate.regionStartTime = v;
      this.animate.setTotalTime();
    }
  }, {
    key: "regionEndTime",
    get: function get() {
      return this.animate.regionEndTime || this.animate.totalTime;
    },
    set: function set(v) {
      this.animate.regionEndTime = v;
      this.animate.setTotalTime();
    }
  }]);

  return Tween;
}();

var TweenOne = function TweenOne(targets, vars) {
  if (!targets) {
    return console.error("Error: targets is undefined.");
  }

  if (ticker.state !== 'wake') {
    // 先将 ticker 唤醒，避免同时添加时 initTime 出错；
    ticker.wake();
  }

  var t = dataToArray(targets).map(function (item) {
    item._tweenOneVars = item._tweenOneVars || {};
    return item;
  }); // 分解 targets 里的元素类型

  var doms = t.filter(function (c) {
    return c.tagName;
  });
  var objs = t.filter(function (c) {
    return !c.tagName;
  });
  var tween = [];

  if (doms.length) {
    tween.push(new Tween(doms, vars));
  }

  if (objs.length) {
    tween.push(new Tween(objs, vars));
  }

  return flatArray(tween);
};

TweenOne.kill = function (targets) {
  if (typeof targets === 'undefined') {
    globalTimeline.killAll(true);
  } else {
    globalTimeline.kill(dataToArray(targets));
  }
};

TweenOne.plugins = Plugins;
export default TweenOne;
export { Tween, globalTimeline };